module.exports = __webpack_public_path__ + "img/5.ea6f41e9.jpg";